module.exports = __webpack_public_path__ + "static/Img_17-554d7538bb65a3916552b79e29602a03.jpg";